import { render } from "./SelectedFiltersComponent.vue?vue&type=template&id=97d02f24&scoped=true"
import script from "./SelectedFiltersComponent.vue?vue&type=script&lang=js"
export * from "./SelectedFiltersComponent.vue?vue&type=script&lang=js"

import "./SelectedFiltersComponent.vue?vue&type=style&index=0&id=97d02f24&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d02f24"]])

export default __exports__